import { hmapPathParamConfig, hmapPathParamRegex } from "@ngmodules/hmap/hmap.routes";
export const InterviewQuestionsBankRoutes = [
    {
        "url": `/interview-questions-bank/${hmapPathParamRegex}?tab`,
        "name": "appLayout.harriSH.access-portal.settings.interview-questions-bank",
        "type": "frontend",
        "reloadOnSearch": false,
        "loginRequired": true,
        "showGlobalSearch": true,
        "component": 'interviewQuestionsBankContainer',
        "params": {
            ...hmapPathParamConfig
        },
        "route_styles": {
            styles: ["interview-questions-bank", "centralized-settings"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Interview Questions Bank"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/interview-questions-bank/interview-questions-bank.downgrade.module");
                }
            }
        ],
        "onEnter": ['$state', '$stateParams', 'brandServices', 'hUser',
            function ($state, $stateParams, brandServices, hUser) {
                brandServices.checkAll(hUser.getActiveBrandIdWithAccess(), [brandServices.SERVICES.QUESTION_BANK, brandServices.SERVICES.VIDEO_INTERVIEW], true)
                    .then((services) => {
                    if (!services[brandServices.SERVICES.QUESTION_BANK] && !services[brandServices.SERVICES.VIDEO_INTERVIEW]) {
                        if (hUser.isTopLevelContext()) {
                            Utils.redirectToWorkspace("appLayout.harriSH.main");
                        }
                        else {
                            $state.go("appLayout.harriSH.dashboard");
                        }
                    }
                });
            }]
    },
    {
        "url": `/question/create/${hmapPathParamRegex}?question_id&brand_id&tab&source`,
        "name": "appLayout.harriSH.access-portal.settings.create-question",
        "type": "frontend",
        "params": {
            ...hmapPathParamConfig
        },
        "loginRequired": true,
        "reloadOnSearch": false,
        "showGlobalSearch": true,
        "component": 'createQuestionWizardContainer',
        "route_styles": {
            styles: ["interview-questions-bank", "centralized-settings"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Create Question"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/interview-questions-bank/interview-questions-bank.downgrade.module");
                }
            }
        ]
    },
    {
        "url": `/template/create/${hmapPathParamRegex}?template_id&brand_id&tab&source`,
        "name": "appLayout.harriSH.access-portal.settings.create-template",
        "type": "frontend",
        "params": {
            ...hmapPathParamConfig
        },
        "loginRequired": true,
        "reloadOnSearch": false,
        "showGlobalSearch": true,
        "component": 'createTemplateWizardContainer',
        "route_styles": {
            styles: ["interview-questions-bank", "centralized-settings"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Create Template"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/interview-questions-bank/interview-questions-bank.downgrade.module");
                }
            }
        ]
    },
    {
        "url": "/question/create?question_id&brand_id&tab&source",
        "name": "appLayout.harriSH.create-question",
        "type": "frontend",
        "loginRequired": true,
        "reloadOnSearch": false,
        "showGlobalSearch": true,
        "component": 'createQuestionWizardContainer',
        "route_styles": {
            styles: ["interview-questions-bank"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Create Question"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/interview-questions-bank/interview-questions-bank.downgrade.module");
                }
            }
        ]
    },
    {
        "url": "/template/create?template_id&brand_id&tab&source",
        "name": "appLayout.harriSH.create-template",
        "type": "frontend",
        "loginRequired": true,
        "reloadOnSearch": false,
        "showGlobalSearch": true,
        "component": 'createTemplateWizardContainer',
        "route_styles": {
            styles: ["interview-questions-bank"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Create Template"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/interview-questions-bank/interview-questions-bank.downgrade.module");
                }
            }
        ]
    },
    {
        "url": "/introduction-video/create?brand_id&source",
        "name": "appLayout.harriSH.create-introduction-video",
        "type": "frontend",
        "loginRequired": true,
        "reloadOnSearch": false,
        "showGlobalSearch": true,
        "component": 'createIntroductionVideoWizardContainer',
        "route_styles": {
            styles: ["interview-questions-bank"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Add Introduction Video"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/interview-questions-bank/interview-questions-bank.downgrade.module");
                }
            }
        ]
    },
    {
        "url": `/introduction-video/create/${hmapPathParamRegex}?brand_id&source`,
        "name": "appLayout.harriSH.access-portal.settings.create-introduction-video",
        "type": "frontend",
        "params": {
            ...hmapPathParamConfig
        },
        "loginRequired": true,
        "reloadOnSearch": false,
        "showGlobalSearch": true,
        "component": 'createIntroductionVideoWizardContainer',
        "route_styles": {
            styles: ["interview-questions-bank", "centralized-settings"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Add Introduction Video"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/interview-questions-bank/interview-questions-bank.downgrade.module");
                }
            }
        ]
    },
    {
        "url": "/:view?tab",
        "name": "appLayout.harriSH.settings.brandSection",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['interview-questions-bank', 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/interview-questions-bank/interview-questions-bank.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/brand/:brand_id/interview-questions-bank?tab",
        "name": "appLayout.harriSH.interview-questions-bank",
        "type": "frontend",
        "reloadOnSearch": false,
        "loginRequired": true,
        "showGlobalSearch": true,
        "component": 'interviewQuestionsBankContainer',
        "route_styles": {
            styles: ["interview-questions-bank"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Interview Questions Bank"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/interview-questions-bank/interview-questions-bank.downgrade.module");
                }
            }
        ],
        "onEnter": ['$state', '$stateParams', 'brandServices', 'hUser',
            function ($state, $stateParams, brandServices, hUser) {
                brandServices.checkAll(parseInt($stateParams['brand_id']), [brandServices.SERVICES.QUESTION_BANK, brandServices.SERVICES.VIDEO_INTERVIEW], true)
                    .then((services) => {
                    if (!services[brandServices.SERVICES.QUESTION_BANK] && !services[brandServices.SERVICES.VIDEO_INTERVIEW]) {
                        $state.go("appLayout.harriSH.dashboard");
                    }
                });
            }]
    }
];
//# sourceMappingURL=interview-questions-bank.routes.js.map